'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIconBase = require('react-icon-base');

var _reactIconBase2 = _interopRequireDefault(_reactIconBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var TiSpanner = function TiSpanner(props) {
    return _react2.default.createElement(
        _reactIconBase2.default,
        _extends({ viewBox: '0 0 40 40' }, props),
        _react2.default.createElement(
            'g',
            null,
            _react2.default.createElement('path', { d: 'm33.8 11.9c-0.1-0.3-0.3-0.5-0.6-0.6-0.3-0.1-0.6 0-0.8 0.2l-4.3 4.3-3.2-0.7-0.7-3.2 4.4-4.3c0.3-0.2 0.3-0.5 0.3-0.7s-0.3-0.6-0.6-0.7c-0.9-0.2-1.7-0.4-2.5-0.4-4.6 0-8.3 3.8-8.3 8.4 0 0.5 0.1 1.1 0.2 1.7-0.9 0.7-1.8 1.4-2.8 2.1-1.5 1.1-3.1 2.3-5.3 4.2-1.3 1.2-2.1 2.8-2.1 4.5 0 3.2 2.6 5.8 5.8 5.8 1.7 0 3.4-0.8 4.5-2.1 1.9-2.2 3.1-3.9 4.2-5.3 0.7-1 1.4-1.9 2.1-2.8 0.6 0.1 1.2 0.2 1.7 0.2 4.6 0 8.4-3.7 8.4-8.3 0-0.8-0.1-1.5-0.4-2.3z m-20.5 16.4c-0.9 0-1.6-0.7-1.6-1.6s0.7-1.7 1.6-1.7 1.7 0.7 1.7 1.7-0.7 1.6-1.7 1.6z' })
        )
    );
};

exports.default = TiSpanner;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/react-icons/lib/ti/spanner.js
// module id = 2201
// module chunks = 0